var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCloudCheck = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "-1 -1 18 18",
  width: 16,
  height: 16,
  fill: "currentColor"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M4.5 12A3.5 3.5 0 0 1 1 9.5a3.5 3.5 0 0 1 2.9-3.45A5 5 0 0 1 8.5 2a5 5 0 0 1 4.9 4.05A3 3 0 0 1 15 9a3 3 0 0 1-3 3H4.5z",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.2
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "m5.5 8 2 2L11 6.5",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default SvgCloudCheck;